<template>
  <div id="error-page">
    <h1>システム障害が発生しております。。</h1>
    <h2>復旧するまでお待ちください。</h2>

    <pre><i v-text="errorMessage"></i></pre>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters("err", ["errorMessage"])
  }
}
</script>